import { accessCodeExists } from './conditionsAccessCode'

const accessCodeValidate = values => {
  let errors = {}
  errors = accessCodeExists({
    inputValue: values.accessCode,
    inputName: 'accessCode',
    errorText: 'Campo obrigatório',
    errors,
  })

  return errors
}

export default accessCodeValidate
